export enum TaskStatus {
  OPENED = "OPENED", // 요청됨
  IN_PROGRESS = "IN_PROGRESS", // 진행중
  REVIEW = "REVIEW", // 검토대기
  CLOSED = "CLOSED", // 완료됨
  CANCELED = "CANCELED", // 취소됨
}
